<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateStrategicValue"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full md:h-auto h-screen overflow-y-auto-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Add Strategic Value</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>
          <transition>
            <div
              v-if="inputError"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ inputError }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <!-- Name -->
            <div class="text-sm">
              <label class="block pb-1">Name</label>
              <input
                v-model="info.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <!-- ExpectedWeight -->
            <div class="text-sm">
              <label class="block pb-1"
                >Expected Weight(%)
                <el-popover trigger="hover" width="250" placement="top-left"
                  ><el-button
                    slot="reference"
                    class="el-icon-info"
                    type="text"
                  ></el-button>
                  <p>
                    <em>Expected Weight</em> must add up to 100% and thus should
                    be distributed across values incase of multiple values.
                  </p></el-popover
                ></label
              >
              <input
                :value="displayValue"
                @input="onInput"
                @focus="onFocus"
                @blur="onBlur"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Description</label>
              <RichTextEditor @content-changed="handleContentChanged" />
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import RichTextEditor from "@/components/editor/RichTextEditor.vue";

export default {
  name: "CreateReviewPeriod",
  props: ["showCreateStrategicValue", "reload"],
  components: { Loader, RichTextEditor },
  data() {
    return {
      info: {
        StrategicGoal: null,
        Name: null,
        Description: null,
        ExpectedWeight: "",
      },
      strategicGoals: [],
      isFocused: false,
      rawInput: "",
      inputError: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),

    displayValue() {
      // Display raw input when focused, formatted percentage when blurred
      return this.isFocused ? this.rawInput : `${this.info.ExpectedWeight}%`;
    },
  },
  watch: {
    inputError() {
      setTimeout(() => {
        this.inputError = "";
      }, 3000);
    },
  },
  methods: {
    handleContentChanged(newContent) {
      this.info.Description = newContent;
    },
    close() {
      this.$emit("close");
    },
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      try {
        // /{organization}/performance/strategic/value/v1/create
        axios
          .post(
            `${this.getOrganization}/performance/strategic/value/${this.$ApiVersion}/create`,
            JSON.stringify(this.info),
            options
          )
          .then((response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("close");
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });
              this.info = {
                ReviewPeriodId: null,
                Name: null,
                Description: null,
                Weight: "",
              };
              this.reload();
            } else {
              this.loading = false;
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$notify.error({
              title: "Failure",
              message: error?.message,
            });
          });
      } catch (error) {
        this.loading = false;
        this.$notify.error({
          title: "Failure",
          message: error?.message,
        });
      }
    },
    fetchStrategicGoals() {
      // Fetch financial periods as needed
    },
    created() {
      this.fetchStrategicGoals();
    },
    onInput(event) {
      let value = event.target.value;

      // Remove non-numeric characters except for a single decimal point
      value = value.replace(/[^0-9.]/g, "");

      // Ensure only one decimal point is allowed
      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1) {
        // Keep only the first decimal point and remove others
        value =
          value.slice(0, decimalIndex + 1) +
          value.slice(decimalIndex + 1).replace(/\./g, "");
      }

      // Convert to number
      let numericValue = parseFloat(value);

      if (numericValue > 100) {
        this.inputError = "Weight cannot exceed 100%";
        setTimeout(() => {
          this.rawInput = "";
          this.info.ExpectedWeight = "";
        }, 2000);
      }

      // Update raw input and model
      this.rawInput = isNaN(numericValue) ? "" : numericValue.toString();
      this.info.ExpectedWeight = isNaN(numericValue) ? 0 : numericValue;
    },
    onFocus() {
      // On focus, show the raw input value
      this.isFocused = true;
      this.rawInput = this.info.ExpectedWeight.toString();
    },
    onBlur() {
      // On blur, show the formatted value
      this.isFocused = false;
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
